import React from 'react';

export const Impressum = () => {
  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-page)'
    }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 className="display-medium" style={{ marginBottom: 'var(--spacing-xl)' }}>
          Impressum
        </h1>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Angaben gemäß § 5 TMG
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
            Alexander Gross
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
            Gross Coaching
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
            Baererstraße 70
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            21073 Hamburg
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Kontakt
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
            E-Mail: grossfit@web.de
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Telefon: +15773608530
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Alexander Gross
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Streitschlichtung
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Haftung für Inhalte
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Urheberrecht
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>

        <p className="body-medium" style={{ fontStyle: 'italic', color: 'var(--text-light)' }}>
          Stand: Januar 2025
        </p>
      </div>
    </div>
  );
};
